import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Avatar from '@marvelapp/marvel-ui/avatar';
import Image from 'marketing-website/components/modules/Image';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import TrackHover from 'marketing-website/utils/TrackHover';

import PlayIcon from 'marketing-website/components/icons/PlayIcon/index.js';
import cardStyles from './styles/general.module.css';

function InfoBlock({
  avatarOneImage,
  avatarTwoImage,
  download,
  excerpt,
  labelMessage,
  labelLogo,
  image,
  isHovered,
  isVideoHover,
  url,
}) {
  const card = cx(cardStyles.image, {
    [cardStyles.withOverlay]: !isVideoHover,
  });

  const playButtonClass = cx(cardStyles.videoIcon, {
    [cardStyles['videoIcon-hover']]: isHovered,
  });

  return (
    <MarvelLink url={url} download={download} target={'_blank'} block>
      <div className={card}>
        <Image {...image} hasShadow={false} />
        {isVideoHover && (
          <div>
            <div className={playButtonClass} />
            <div className={cardStyles.playIcon}>
              <PlayIcon />
            </div>
          </div>
        )}
        {labelMessage && (
          <div className={cardStyles.label}>
            <Paragraph size="xs">
              {labelLogo && (
                <span className={cardStyles.logo}>{labelLogo}</span>
              )}
              {labelMessage}
            </Paragraph>
          </div>
        )}
        {avatarOneImage && (
          <div>
            <div className={cardStyles.avatarWrap}>
              <Avatar
                shape="circle"
                image={avatarOneImage}
                size="xs"
                borderColor="white"
                boxShadow
              />
              {avatarTwoImage && (
                <Avatar
                  shape="circle"
                  image={avatarTwoImage}
                  size="xs"
                  borderColor="white"
                  boxShadow
                />
              )}
            </div>
          </div>
        )}
      </div>
      <div className={cardStyles.text}>
        <Paragraph size="m">{excerpt}</Paragraph>
      </div>
    </MarvelLink>
  );
}
InfoBlock.propTypes = {
  avatarOneImage: PropTypes.object,
  avatarTwoImage: PropTypes.object,
  download: PropTypes.bool,
  excerpt: PropTypes.string,
  labelMessage: PropTypes.string,
  labelLogo: PropTypes.node,
  image: PropTypes.object.isRequired,
  isHovered: PropTypes.bool,
  isVideoHover: PropTypes.bool,
  url: PropTypes.string,
};

InfoBlock.defaultProps = {
  isVideoHover: false,
  download: false,
};

export default TrackHover(InfoBlock);



// WEBPACK FOOTER //
// ./src/components/modules/infoBlock/index.js